(function ($) {
    $.fn.lmHeader = function(options) {
        // NOTE: Don't run logic below if nothing is in the dom
        if (!this.length) {
            return false;
        }

        // Default settings are set here
        var settings = $.extend({
            menuItems: 'main-menu__item',
            dropdown: 'dropdown--open',
            menuLinks: 'main-menu__link',
            mobileButton: 'mobile-header__menu',
            search: 'search',
            searchUrl: '/search',
            //offset: 80,
            offset: 78,
            breakpoint: 980,
            mainNav: 'main-nav__menu'
        }, options);

        // These are all the methods available for the plugin
        var methods = {};

        // Necessary default values for sticky header
        var $this = this;

        var resizeTimeout = null;
        var activeSticky = true;
        var top = 0;
        var lastTop = 0;
        var startTop = 0;
        var reverseTop = 0;
        var continueTop = 0;
        var upZone = false;
        var absoluteZone = false;
        var goingUpSticky = false;
        var $ele = $(this);
        var $video = $('#featureVideo');
        var $videoWrapper = $video.closest('.container');
        var $videoWrapperClass = 'container--absolute';
        var $body = $('body');
        var $window = $(window);
        var $document = $(document);
        var $alert = $('#alert');
        var $mainNavLogo = $('.main-nav__logo');


        methods.resetSticky = function() {
            // reset all variables
            top = 0;
            lastTop = 0;
            startTop = 0;
            reverseTop = 0;
            continueTop = 0;
            upZone = false;
            absoluteZone = false;
            goingUpSticky = false;
            $ele.removeAttr('style');
            if($video.length) {
                $video.removeAttr('style');
                $videoWrapper.removeClass($videoWrapperClass);
            }
            $body.removeClass('has-sticky-header has-sticky-header--reverse has-sticky-header--absolute');
            if($body.hasClass('user-logged-in')) {
                $mainNavLogo.addClass('user-logged-in');
            }
        }

        methods.setCookie = function(name, value) {
            var date = new Date(); var days = 1;
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
            var cookie = [name + '=' + escape(value) + expires, '; domain=' + window.location.host + '; path=/;' ].join('');
            document.cookie = cookie;

            if(methods.getCookie(name)) {
                return true;
            } else {
                return false;
            }
        }

        methods.getCookie = function(name) {
            var nameLength = name.length;
            var result = document.cookie.match(RegExp(name + '=[^;]+'));

            if(result != null) {
                return result[0].substr(nameLength+1);
            } else {
                return false;
            }
        }

        methods.setZoneMarkers = function() {
            reverseTop = top - settings.offset;
            continueTop = top;
        }

        methods.endAbsolute = function() {
        	if(!activeSticky) {
            absoluteZone = false;
            $body.removeClass('has-sticky-header--absolute');
            $ele.removeAttr('style');

            if($video.length) {
                $video.removeAttr('style');
                $videoWrapper.removeClass($videoWrapperClass);
            }
            }
        }

        methods.startAbsolute = function(thisTop) {
            if(!activeSticky) {
            absoluteZone = true;
            $body.addClass('has-sticky-header--absolute');
            $ele.css({
                top: thisTop
            });
            if($video.length) {
                $video.css({
                    top: thisTop - 115
                });
                $videoWrapper.addClass($videoWrapperClass);
            }
        }
    	}

        methods.goingDown = function() {
            if (upZone) {

                upZone = false;
                absoluteZone = true;
                startTop = top + settings.offset;
                methods.startAbsolute(top);
            } else if (top > startTop) {

                reverseTop = 0;
                continueTop = 0;
                methods.endAbsolute();
            }
            goingUpSticky = false;
            $body.addClass('has-sticky-header').removeClass('has-sticky-header--reverse');
        }

        methods.goingUp = function() {
            if (!goingUpSticky && !absoluteZone && top > settings.offset) {

                methods.setZoneMarkers();
                methods.startAbsolute(reverseTop);
            } else if (top < reverseTop && !$body.hasClass('has-sticky-header--reverse') && !upZone && absoluteZone) {

                upZone = true;
                absoluteZone = false;
                goingUpSticky = true;
                $body.addClass('has-sticky-header--reverse').removeClass('has-sticky-header--absolute');
                $ele.removeAttr('style');
                if($video.length) {
                    $video.removeAttr('style');
                    $videoWrapper.removeClass($videoWrapperClass);
                }
            } else if (top < reverseTop && $body.hasClass('has-sticky-header--reverse') && upZone && !absoluteZone) {
                methods.setZoneMarkers();
            }
        }

        methods.toggleSticky = function() {
            var width = $window.width();
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function(){
                if (width < settings.breakpoint) {
                    activeSticky = false;
                } else {
                    activeSticky = true;
                }
                methods.resetSticky();
                $mainNavLogo.css("display","flex");
            }, 250);
        }

        methods.initSubMenuTabIndex = function() {
            // Set tabindex="-1" when the page loads for the social-menu__link items in the heade submenu only.
            $('.more-menu .submenu-wrapper .social-menu__link').each(function (i) { $(this).attr('tabindex', '-1'); });
        }

        methods.setCurrentSettings = function() {
            var currentSettings = $this.data();
            if (!$.isEmptyObject(currentSettings)) {
                $this.data($.extend({}, settings, currentSettings));
            } else {
                $this.data(settings);
            }

            // Check if alert exist, if so, offset needs to include this.
            if ($alert.length) {
                settings.offset = 120;
                $body.addClass('has-alert');
            }

            if (methods.getCookie('hideAlert')) {
                settings.offset = 80;
                $body.addClass('has-alert-hidden');
                $mainNavLogo.animate({top: "-1px"});
            }

            // Initialize item
            $this.data('initialized', true);
        }

        methods.events = function() {
            var _lmHeaderSelector = '.' + settings.menuItems + '.' + settings.menuItems + '--has-submenu > a';
            $('.main-nav').off('click.lmHeader').on('click.lmHeader', _lmHeaderSelector, function(evt) {
                evt.preventDefault();
                evt.stopPropagation();

                var $this_parent = $(this).parent();

                $this_parent.siblings('.show-menu').addClass('hide-menu').removeClass('show-menu');

                $('.' + settings.dropdown).addClass('dropdown--closed').removeClass('dropdown--open');
                $('.has-share-drop--show').addClass('has-share-drop--hide').removeClass('has-share-drop--show');
                if ($this_parent.hasClass('show-menu')) {
                    $this_parent.addClass('hide-menu').removeClass('show-menu');
                    $('.more-menu .submenu-wrapper .submenu__link').each(function (i) { $(this).attr('tabindex', '-1'); });
                    $('.more-menu .submenu-wrapper .social-menu__link').each(function (i) { $(this).attr('tabindex', '-1'); });
                } else {
                    $this_parent.removeClass('hide-menu').addClass('show-menu');
                    $('.more-menu .submenu-wrapper .submenu__link').each(function (i) { $(this).attr('tabindex', '0'); });
                    $('.more-menu .submenu-wrapper .social-menu__link').each(function (i) { $(this).attr('tabindex', '0'); });
                }
            });

            var $searchButton = $this.find('.' + settings.search + ' > .button');
            $searchButton.off('click.lmHeader').on('click.lmHeader', function(evt) {
                evt.preventDefault();
                $(this).siblings('form').find('input').focus();
                $(this).parent().toggleClass('search--open');
            });

            var $mobileButton = $this.find('.' + settings.mobileButton + ' .button');
            $mobileButton.off('click.lmHeader').on('click.lmHeader', function(evt) {
                evt.preventDefault();
                $this.toggleClass('show-mobile-menu');
            });

            var $alertCloseButton = $alert.find('.alert__close');
            $alertCloseButton.off('click.lmHeader').on('click.lmHeader', function(evt) {
                evt.preventDefault();
                settings.offset = 80;
                $body.addClass('has-alert-hidden');
                methods.setCookie('hideAlert','true');
            });

            $document.off('click.lmHeader').on('click.lmHeader', function(evt){
                if (!$(evt.target).hasClass(settings.menuLinks)) {
                    $buttonWithDropdown.removeClass('show-menu');
                }
            });

            $(document).off('click.lmHeader').on('click.lmHeader', function(evt) {
                $('.show-menu').addClass('hide-menu').removeClass('show-menu');
            });

            $window.off('resize.lmHeader').on('resize.lmHeader', function(){
                methods.toggleSticky();
            });

            $window.off('scroll.lmHeader').on('scroll.lmHeader', function(){
                if (activeSticky) {
                    top = $(this).scrollTop();

                    if (top == 0) {
                        methods.resetSticky();
                    } else {
                        if (top > lastTop && top > settings.offset) {
                            methods.goingDown();
                        } else {
                            methods.goingUp();
                        }
                    }
                    lastTop = top;
                }
            });

            $window.scroll(function() {
                var logoContainer = $('.main-nav__logo.user-logged-in');
                if (logoContainer) {
                    var offset = logoContainer.offset();
                    var top = (offset) ? offset.top : 0;
                    var pos = logoContainer.position();
                    var bot = ((pos) ? pos : 0) + logoContainer.outerHeight(true) + 80;

                    var target = $('.main-nav__menu').offset().top;
                    var pagePos = $('.hero');
                    if( pagePos.length > 0) {
                      pagePos = $('.hero').position().top;
                      var scrollTop =  $(this).scrollTop();

                      //if(scrollTop <= 55) {
                      if(scrollTop <= 43) {
                        $('.main-nav__logo.user-logged-in').css("display","block");

                        } else {
                          $('.main-nav__logo.user-logged-in').css("display","none");
                        }
                      }
                }
            });

            methods.toggleSticky();
        }

        // Run once methods when jquery plugin is called
        methods.setCurrentSettings();
        methods.events();
        methods.initSubMenuTabIndex();
        return this;
};

}(jQuery));
